import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  id: "main",
  class: "trust",
  tabindex: "-1"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "trust__head" }
const _hoisted_4 = { class: "trust__status" }
const _hoisted_5 = { class: "trust__docs" }
const _hoisted_6 = { class: "eyebrow" }
const _hoisted_7 = { class: "trust__contact" }
const _hoisted_8 = ["href"]

import SiteNav from "@/components/site/SiteNav.vue";
import SiteFooter from "@/components/site/SiteFooter.vue";
import { LEGAL_STATUS, legalDocs, legalLinks } from "@/content/legal";
import { SUPPORT_EMAIL } from "@/content/links";

export default /*@__PURE__*/_defineComponent({
  __name: 'LegalHubView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(SiteNav, { solid: "" }),
    _createElementVNode("main", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("header", _hoisted_3, [
          _cache[0] || (_cache[0] = _createElementVNode("p", { class: "eyebrow" }, "Privacy & terms", -1)),
          _cache[1] || (_cache[1] = _createElementVNode("h1", null, [
            _createTextVNode("Clear choices."),
            _createElementVNode("br"),
            _createElementVNode("span", null, "Considered rules.")
          ], -1)),
          _cache[2] || (_cache[2] = _createElementVNode("p", null, " Know how your conversations work, what information the service uses and how to take control of your account. ", -1)),
          _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(LEGAL_STATUS)) + " · October 1, 2026", 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(legalLinks), (link) => {
            return (_openBlock(), _createBlock(_component_router_link, {
              key: link.key,
              to: link.path,
              class: "trust__doc"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(legalDocs)[link.key].category), 1),
                _createElementVNode("h2", null, [
                  _createTextVNode(_toDisplayString(_unref(legalDocs)[link.key].title) + " ", 1),
                  _cache[3] || (_cache[3] = _createElementVNode("span", { "aria-hidden": "true" }, "↗", -1))
                ]),
                _createElementVNode("p", null, _toDisplayString(link.description), 1),
                _cache[4] || (_cache[4] = _createElementVNode("span", { class: "trust__read" }, "Read document →", -1))
              ]),
              _: 2
            }, 1032, ["to"]))
          }), 128))
        ]),
        _cache[7] || (_cache[7] = _createElementVNode("section", {
          class: "trust__choices",
          "aria-labelledby": "choices-title"
        }, [
          _createElementVNode("div", null, [
            _createElementVNode("p", { class: "eyebrow" }, "Before you share"),
            _createElementVNode("h2", { id: "choices-title" }, "Know your chat mode.")
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("h3", null, "Secure chats"),
            _createElementVNode("p", null, " End-to-end encrypted messages on supported platforms. Delivery metadata and recipient copies still exist. ")
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("h3", null, "Ordinary & group chats"),
            _createElementVNode("p", null, " Cloud history with server-managed encryption. The service processes message content; these chats are not end-to-end encrypted. ")
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_7, [
          _cache[5] || (_cache[5] = _createElementVNode("h2", null, "Need help with a privacy request?", -1)),
          _createElementVNode("a", {
            href: `mailto:${_unref(SUPPORT_EMAIL)}?subject=Allading%20privacy%20request`
          }, _toDisplayString(_unref(SUPPORT_EMAIL)) + " ↗", 9, _hoisted_8),
          _cache[6] || (_cache[6] = _createElementVNode("p", null, " Share enough to identify your request. Keep passwords, verification codes and your backup PIN private. ", -1))
        ])
      ])
    ]),
    _createVNode(SiteFooter)
  ]))
}
}

})